// @flow
import { connect } from 'react-redux'
import PricelistSelect from './PricelistSelect'
import type { Store } from '../../redux/store'
import * as reducer from '../../redux/ducks/pricelistEdit/reducers'
import type { State } from '../../redux/ducks/pricelistEdit/reducers'
import type { OptionType } from '../types'

type OwnProps = {|
  initialOptions: Array<OptionType>,
  initialName: string,
  isDisabled: boolean,
  onChange: Function
|}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const { pricelistId } = state.audienceEdit
  const { options, name } = state.pricelistEdit
  return {
    ...ownProps,
    id: pricelistId,
    options,
    name
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: OwnProps) {
  return {
    onInit: (initial: State) => {
      dispatch(reducer.init(initial))
    },
    onCreate: () => {
      dispatch(reducer.patch({ isOpen: true }))
    },
    onChange: (pricelistId) => {
      ownProps.onChange(pricelistId)
    }
  }
}

const PricelistSelectContainer = connect<Object, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(PricelistSelect)

export default PricelistSelectContainer
